import React from 'react';
import style from './style';
import i18next from 'i18next';
import EAIcon from '../../../../../components/common/EAIcon';
import { getExpirationDate } from '../../../../Context/ContextDetail/Informations';
import ModificationDate from '../../../../../components/context/ModificationDate';
import Attribute from '../../../../Context/AddContext/steps/ContextAttributes/Attribute';
import EAAccordion from '../../../../../components/EAAccordion';
import { getLatestUpdateDateFormatted } from '../../../../Context/ContextDetail';
import { Grid } from '@mui/material';

const ExistingContext = ({ contextInstance, contextModel }) => {
  const { classes } = style();
  const contextAttributes =  contextInstance.contextAttributes;
  const contextAttributesUpdateDate = getLatestUpdateDateFormatted(contextAttributes);

  return (
    <div className={classes.root}>
      <div className={classes.title}>
        {i18next.t('thirdpartySheet.contextTp.selectedDetails')}
      </div>
      <div className={classes.infosContainer}>
        <div className={classes.infosTitleContainer}>
          <EAIcon icon={'context/tpSheet/existingContext'} />
          <div className={classes.infosNameContainer}>
            <div className={classes.modelName}>
              {contextInstance.contextModelName}
            </div>
            <div className={classes.reference}>{contextInstance.reference}</div>
          </div>
        </div>
        <div className={classes.data}>
          {contextInstance && (
            <div className={classes.description}>
              <div className={classes.descriptionTitle}>
                {i18next.t('thirdpartySheet.contextTp.description')}
              </div>
              <div className={classes.descriptionText}>
                {contextInstance.description.length?
                  contextInstance.description:
                i18next.t('notSpecified')}
              </div>
            </div>
          )}
          <div className={classes.expDateContainer}>
            <div className={classes.label}>
              {i18next.t('context.contextDetail.expirationDate')}
            </div>
            <div className={classes.expirationDate}>
              <EAIcon icon={'/context/calendar'} />
              <div className={classes.expirationDateText}>
                {getExpirationDate(contextInstance.expirationDate)}
              </div>
            </div>
          </div>
        </div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <EAAccordion
              id={'general'}
              title={i18next.t(`context.contextDetail.blocks.general`)}
              logo="/context/attributs_block"
              opened={true}
              counter={contextAttributes.length}
              disabled={contextAttributes.length === 0}
              buttons={
                contextAttributesUpdateDate
                  ? [<ModificationDate date={contextAttributesUpdateDate} />]
                  : []
              }
            >
              <div className={classes.attributeContainer}>
                {contextAttributes.map((contextAttribute) => (
                  <Attribute
                    contexteAttribute={contextAttribute}
                    onValidateSuccess={()=>{}}
                    currentValue={contextAttributes.find(
                      (c) => c.label === contextAttribute.label
                    )}
                    disabled={true}
                  />
                ))}
              </div>
            </EAAccordion>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ExistingContext;
